<!-- 拆箱管理 -->
<template>
    <div class="container">
        <div class="content">
            <Tabs value="small_name">
                <!-- 拆小箱-->
                <TabPane
                    label="拆小箱操作（将产品从小箱内拆出）"
                    name="small_name"
                >
                    <Form
                        :model="formData"
                        label-position="right"
                        :label-width="100"
                    >
                        <FormItem label="录入方式">
                            <RadioGroup v-model="formData.type" type="button">
                                <Radio label="1">溯源码拆箱</Radio>
                                <Radio label="3">小箱码拆箱</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="录入溯源码:">
                            <div class="dis-flex">
                                <Input
                                    @input="handleInputChange"
                                    class="w30 mr24"
                                    type="textarea"
                                    v-model="qrcode_number"
                                    :autosize="{ minRows: 10 }"
                                    placeholder="录入溯源码，小箱码，大箱码，发货码，一行一个，支持手动和扫码枪扫码录入"
                                ></Input>
                                <div
                                    style="
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: space-between;
                                    "
                                >
                                    <div>支持手动和扫码枪扫码录入</div>
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                            cursor: pointer;
                                        "
                                        @click="setNull"
                                    >
                                        <img
                                            src="@/assets/blank.png"
                                            alt=""
                                            style="
                                                display: block;
                                                margin-right: 6px;
                                            "
                                        />
                                        <div>置空</div>
                                    </div>
                                </div>
                            </div>
                        </FormItem>
                        <div class="footer">
                            <Button class="mr24" @click="cancelSmall"
                                >取消</Button
                            >
                            <Button
                                class="theme-bc theme-default-color"
                                @click="submitSmall"
                                >确定</Button
                            >
                        </div>
                    </Form>
                </TabPane>
                <!-- 拆大箱-->
                <TabPane
                    label="拆大箱操作（将小箱从大箱内拆出）"
                    name="large_name"
                >
                    <Form
                        :model="formData"
                        label-position="right"
                        :label-width="100"
                    >
                        <FormItem label="录入方式">
                            <RadioGroup v-model="formData.type" type="button">
                                <Radio label="2">小箱码拆箱</Radio>
                                <Radio label="4">大箱码拆箱</Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="录入小箱码：">
                            <div class="dis-flex">
                                <Input
                                    @input="handleInputChange"
                                    class="w30 mr24"
                                    type="textarea"
                                    v-model="qrcode_number"
                                    :autosize="{ minRows: 10 }"
                                    placeholder="录入小箱码，一行一个，支持手动和扫码枪扫码录入"
                                ></Input>
                                <div
                                    style="
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: space-between;
                                    "
                                >
                                    <div>支持手动和扫码枪扫码录入</div>
                                    <div
                                        style="
                                            display: flex;
                                            align-items: center;
                                            cursor: pointer;
                                        "
                                        @click="setNull"
                                    >
                                        <img
                                            src="@/assets/blank.png"
                                            alt=""
                                            style="
                                                display: block;
                                                margin-right: 6px;
                                            "
                                        />
                                        <div>置空</div>
                                    </div>
                                </div>
                            </div>
                        </FormItem>
                        <div class="footer">
                            <Button class="mr24" @click="cancelSmall"
                                >取消</Button
                            >
                            <Button
                                class="theme-bc theme-default-color"
                                @click="submitSmall"
                                >确定</Button
                            >
                        </div>
                    </Form>
                </TabPane>
            </Tabs>
        </div>
    </div>
</template>

<script>
import { packing_unpack } from "@/api/index";
export default {
    data() {
        return {
            qrcode_number: "",
            formData: {
                qrcode_number: [],
                type: "1",
            },
        };
    },
    mounted() {},
    methods: {
        setNull() {
            this.qrcode_number = "";
            this.formData.qrcode_number = [];
        },
        // 确定
        submitSmall() {
            if (this.qrcode_number) {
                this.formData.qrcode_number = this.qrcode_number
                    .split("\n")
                    .map((item) => (item === "" ? null : item)) // 将空字符串转�?null
                    .filter((item) => item !== null); // 过滤掉所�?null �?
            }
            if (this.formData.type == 1) {
                var data = {
                    type: this.formData.type,
                    qrcode_number: this.formData.qrcode_number,
                };
            } else if (this.formData.type == 2 || this.formData.type == 3) {
                var data = {
                    type: this.formData.type,
                    small_box_number: this.formData.qrcode_number,
                };
            } else if (this.formData.type == 4) {
                var data = {
                    type: this.formData.type,
                    big_box_number: this.formData.qrcode_number,
                };
            }
            packing_unpack(data)
                .then((res) => {
                    this.$Message.success(res.msg);
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
        cancelSmall() {
            this.qrcode_number = "";
            this.formData.qrcode_number = [];
        },
        handleInputChange(e) {
            // 获取当前输入框的�?
            const inputValue = e.target ? e.target.value : e;
            // 按换行符分割为数组（处理多行输入�?
            const lines = inputValue.split("\n");
            // 用于存储处理后的所有码
            const allCodes = [];
            // 匹配完整URL的正则表达式（支持https/http�?
            const urlPattern = /https?:\/\/[^\s?]+\?q=([\w]+)/g;
            // 处理每一行数�?
            lines.forEach((line) => {
                // 处理行内的所有URL
                let match;
                let lastIndex = 0;
                const results = [];
                // 1. 提取行内所有URL的q参数�?
                while ((match = urlPattern.exec(line)) !== null) {
                    // 添加URL前可能存在的非URL文本
                    if (match.index > lastIndex) {
                        const textBefore = line
                            .substring(lastIndex, match.index)
                            .trim();
                        if (textBefore) results.push(textBefore);
                    }
                    // 添加提取的q参数�?
                    results.push(match[1]);
                    // 更新lastIndex
                    lastIndex = match.index + match[0].length;
                }
                // 2. 添加最后一个URL后的剩余文本
                if (lastIndex < line.length) {
                    const textAfter = line.substring(lastIndex).trim();
                    if (textAfter) results.push(textAfter);
                }
                // 3. 处理没有URL的直接输入码
                if (results.length === 0) {
                    const directCodeMatch = line.match(/^([\w\-.]+)\s*$/);
                    if (directCodeMatch) {
                        results.push(directCodeMatch[1]);
                    } else {
                        results.push(line); // 保留原始行内�?
                    }
                }
                // 收集当前行的所有结�?
                allCodes.push(...results);
            });
            // 更新v-model绑定的数据（去除空行�?
            this.qrcode_number = allCodes
                .filter((code) => code.trim() !== "")
                .join("\n");
        },
    },
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
}
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.footer {
    margin: 12px 0 0 0;
    padding: 24px 0 0 0;
    text-align: center;
    border-top: 1px solid #eee;
}
.w30 {
    width: 30vw;
}
.dis-flex {
    display: flex;
}
::v-deep .ivu-tabs-tab {
    font-size: 16px;
}
::v-deep .ivu-tabs-nav .ivu-tabs-tab-active {
    color: var(--primary-color);
    font-size: 16px;
}
::v-deep .ivu-tabs-ink-bar {
    background-color: var(--primary-color) !important;
}
/* 表头字体颜色 */
::v-deep .ivu-table-wrapper .ivu-table .ivu-table-header tr th {
    color: #484e66 !important;
    font-weight: bold;
}
/* table中所有的边框  */
::v-deep .ivu-table td {
    border-left: none;
    border-right: none;
}
::v-deep .ivu-table th {
    border-left: none;
    border-right: none;
}
/* RadioGroup */
::v-deep .ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #53c41a;
    border-color: #53c41a;
    color: #ffffff;
    box-shadow: none;
    z-index: 1;
}
::v-deep .ivu-radio-group-button .ivu-radio-wrapper {
    margin-right: 24px;
}
</style>